import "./save-the-date.scss";

/*
local storage + hooks
- 'save' a state that marks if they've opened it already
- button appears: click to skip?
*/

import { useEffect, useState } from "react";
import { getImageUrls } from "../../utils/getImageUrls";
import { preloadImages } from "../../utils/preloadImages";

export default function SaveTheDate() {
  //loading
  const [isLoaded, setIsLoaded] = useState(false);

  //imageUrls
  const [imageUrls, setImageUrls] = useState([]);

  //animation stage sequence
  const [stageCount, setStageCount] = useState(1); //start at stage 1

  const [countdownTimer, setCountdownTimer] = useState(0); //time in seconds
  const [isCountingDown, setIsCountingDown] = useState(false);

  const defaultTimer = 6; // when to start timer at
  const clickToOpenLimit = defaultTimer - 2;
  const countdownLimit = 2; //

  //how many stages in the animation
  const stageAmt = 3;

  //get image urls from public folder
  useEffect(() => {
    getImageUrls("save-the-date")
      .then(setImageUrls)
      .catch((err) => {
        console.error("Error fetching image URLs:", err);
      });
  }, []);

  //preload images once urls are available
  useEffect(() => {
    if (imageUrls.length === 0) return;

    if (imageUrls.length > 6) {
      preloadImages(imageUrls)
        .then(() => {
          console.log("All images preloaded");
          setIsLoaded(true);
        })
        .catch((err) => {
          console.warn("Preloading error: ", err);
          setIsLoaded(true); //still show page even if preload failed
        });
    }
  }, [imageUrls]);

  //timer
  useEffect(() => {
    if (isLoaded) {
      startTimer?.();
    }
  }, [isLoaded]);

  function handleNextStage() {
    if (stageCount < stageAmt) {
      setStageCount((prev) => prev + 1);
    }
    //remove after testing
    if (stageCount === stageAmt) {
      setStageCount(1);
    }
  }

  function startTimer() {
    setCountdownTimer(defaultTimer);
    setIsCountingDown(true);
  }

  //immediately jumps to the countdown limit
  function skipTimer() {
    setCountdownTimer(countdownLimit);
  }

  //click to open
  function handleClick() {
    if (isLoaded) {
      if (stageCount === 1 && countdownTimer <= clickToOpenLimit) {
        handleNextStage();
        if (stageCount >= 1) {
          startTimer();
        }
      }
      if (stageCount === 2 && countdownTimer <= clickToOpenLimit) {
        skipTimer();
      }
    }
  }

  //timeout click until time passes setTimeout
  useEffect(() => {
    let timer;
    if (isCountingDown && countdownTimer > 0) {
      timer = setTimeout(() => {
        setCountdownTimer((prev) => prev - 1);
        // console.log(countdownTimer);
      }, 1000);
    } else if (countdownTimer === 0 && isCountingDown) {
      setIsCountingDown(false); //stop the timer
      if (stageCount === 2) {
        setStageCount(3);
      }
    }
    return () => clearTimeout(timer); //cleanup
  }, [countdownTimer, isCountingDown]);

  //use countdown timers instead of stage count
  //countdown so that handle click only works when the arrow appears

  return (
    <>
      <div
        id="save-the-date"
        className={`save-the-date sd-content`}
        onClick={handleClick}
      >
        {(stageCount <= 1 ||
          (stageCount === 2 && countdownTimer > countdownLimit)) && (
          <div className={`${stageCount <= 1 ? "" : "fade-out"}`}>
            <img
              className="sd-bg"
              src="/images/save-the-date/00_bg.jpeg"
              alt="background image"
            />
          </div>
        )}
        {isLoaded && (
          <div className="stage-container">
            <div className="stage-wrapper">
              {stageCount === 1 && (
                <div className={`${stageCount <= 1 ? "stage-1" : ""}`}>
                  <img
                    className="envelope rising-fade-in"
                    src="/images/save-the-date/01_closedenvelope.png"
                    alt="closed envelope"
                  />
                  <div
                    className={`${
                      stageCount === 1
                        ? "open-label open-fade-in animation-duration-4s"
                        : "hidden"
                    }`}
                  >
                    <img
                      className="arrow"
                      src="/images/common/arrow.png"
                      alt="arrow pointing up"
                    />
                    <p className="LaRumba no-text-highlight">click to open</p>
                  </div>
                </div>
              )}
              {stageCount === 2 && (
                <div
                  className={`${stageCount === 2 ? "stage-2 fade-in" : ""} ${
                    countdownTimer <= countdownLimit ? "stage-3-transition" : ""
                  }`}
                >
                  <div className="open-envelope-container">
                    <img
                      className={`envelope-back z-0 ${
                        countdownTimer <= countdownLimit ? "envelope-slide" : ""
                      }`}
                      src="/images/save-the-date/02_envelope_back.png"
                      alt="open envelope"
                    />

                    <img
                      className={`envelope-front z-5 ${
                        countdownTimer <= countdownLimit ? "envelope-slide" : ""
                      }`}
                      src="/images/save-the-date/03_envelope_front.png"
                      alt="open envelope front layer"
                    />

                    <div className="polaroid-container z-3">
                      <img
                        className="polaroid photo-popout-right"
                        src="/images/save-the-date/04_polaroid_01.png"
                        alt="polaroid picture"
                      />
                    </div>

                    <div
                      className={`polaroid-container z-2 ${
                        countdownTimer <= countdownLimit ? "photo1-follow " : ""
                      }`}
                    >
                      <img
                        className="polaroid photo-popout-left"
                        src="/images/save-the-date/07_polaroid_03.png"
                        alt="polaroid picture"
                      />
                    </div>

                    {/* slides with the envelope */}
                    <div
                      className={`polaroid-container z-1 ${
                        countdownTimer <= countdownLimit ? "photo2-follow" : ""
                      }`}
                    >
                      <img
                        className="polaroid"
                        src="/images/save-the-date/06_polaroid_02.png"
                        alt="polaroid picture"
                      />
                    </div>
                  </div>

                  <div
                    className={`married-label fade-in z-20 ${
                      countdownTimer <= countdownLimit ? "label-slide" : ""
                    }`}
                  >
                    <img
                      className=""
                      src={imageUrls[5]}
                      alt="we're getting married label"
                    />
                  </div>
                </div>
              )}
              {stageCount === 3 && (
                <div className={`${stageCount === 3 ? "stage-3" : ""}`}>
                  <img
                    className="polaroid-1 z-4 "
                    src={imageUrls[4]}
                    alt="polaroid picture"
                  />
                  <img
                    className="polaroid-2 z-5"
                    src={imageUrls[7]}
                    alt="polaroid picture"
                  />

                  <img
                    className="postcard z-6"
                    src={imageUrls[8]}
                    alt="postcard"
                  />

                  <img
                    className="wax-seal slow-fade-in z-5"
                    src={imageUrls[9]}
                    alt="wax seal"
                  />

                  <div className="open-envelope-container">
                    <img
                      className="envelope-back stage-3-envelope-slide z-1"
                      src={imageUrls[2]}
                      alt="open envelope"
                    />

                    {/* inside the envelope */}
                    <img
                      className="polaroid-3 z-2"
                      src={imageUrls[6]}
                      alt="polaroid picture"
                    />

                    <img
                      className="envelope-front stage-3-envelope-slide z-3"
                      src={imageUrls[3]}
                      alt="open envelope front layer"
                    />
                  </div>

                  <img
                    className="married-label slow-fade-in animation-duration-6s z-10"
                    src={imageUrls[5]}
                    alt="we're getting married label"
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
